(function () {
  var COPY = {
    form_title: 'SNART TILBAGE',
    email_label: 'Din e-mailadresse',
    email_input_placeholder: 'Din e-mailadresse',
    email_input_below_text: 'Kun én mail. Ingen spam.',
    button_text: 'Giv mig besked',
    empty_email_error_message: 'Indtast din e-mailadresse.',
    invalid_email_error_message: 'Indtast en gyldig e-mailadresse.',
    after_subscribe_message_text: 'Du er på listen. Vi giver dig besked, så snart varen er tilbage.',
    already_subscribed_message_text: 'Du er allerede på listen til denne vare.'
  };

  function updateDanishContent(config) {
    if (!config || !Array.isArray(config.ui_contents)) return;

    var danish = config.ui_contents.find(function (entry) {
      return entry && entry.language === 'da';
    });

    if (!danish || !danish.subscription_form_content) return;

    Object.assign(danish.subscription_form_content, COPY);

    if (Array.isArray(danish.notify_me_contents)) {
      var productButton = danish.notify_me_contents.find(function (entry) {
        return entry && entry.page === 'PRODUCT_PAGE';
      });

      if (productButton) {
        productButton.button_text = 'Få besked, når den er tilbage';
      }
    }
  }

  function updateConfig() {
    var restockConfig = window._ReStockConfig;
    if (!restockConfig) return;

    updateDanishContent(restockConfig);

    if (restockConfig._metafields) {
      updateDanishContent(restockConfig._metafields.sdkConfig);
    }
  }

  function improveModalSemantics(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var modals = [];

    if (scope.matches && scope.matches('.restock-alerts-modal-wrapper')) {
      modals.push(scope);
    }

    scope.querySelectorAll('.restock-alerts-modal-wrapper').forEach(function (modal) {
      if (modals.indexOf(modal) === -1) modals.push(modal);
    });

    modals.forEach(function (modal, index) {
      var dialog = modal.querySelector('.restock-alerts-modal-box');
      if (!dialog) return;

      var title = dialog.querySelector('.restock-alerts-form-title');
      var close = modal.querySelector('.restock-alerts-modal-close-btn');
      var closeWrapper = modal.querySelector('.modalCloseButtonWrapper');
      var email = dialog.querySelector('.restock-alerts-email-input');

      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');

      if (title) {
        if (!title.id) title.id = 'vantho-restock-title-' + index;
        dialog.setAttribute('aria-labelledby', title.id);
      }

      if (email) {
        email.setAttribute('inputmode', 'email');
        email.setAttribute('autocomplete', 'email');
        email.setAttribute('spellcheck', 'false');
      }

      function closeModal() {
        var currentClose = modal.querySelector('.restock-alerts-modal-close-btn');
        if (currentClose) {
          currentClose.click();
        } else {
          modal.remove();
        }
      }

      if (closeWrapper && !closeWrapper.querySelector('.vantho-restock-close')) {
        var closeButton = document.createElement('button');
        var closeIcon = document.createElement('span');

        closeButton.type = 'button';
        closeButton.className = 'vantho-restock-close';
        closeButton.setAttribute('aria-label', 'Luk vinduet');
        closeIcon.className = 'vantho-restock-close__icon';
        closeIcon.setAttribute('aria-hidden', 'true');
        closeIcon.textContent = '×';
        closeButton.appendChild(closeIcon);
        closeButton.addEventListener('click', closeModal);
        closeWrapper.appendChild(closeButton);
        closeWrapper.classList.add('vantho-restock-close-ready');

        if (close) {
          close.setAttribute('aria-hidden', 'true');
          close.setAttribute('tabindex', '-1');
        }
      }

      if (!modal.dataset.vanthoBackdropReady) {
        modal.dataset.vanthoBackdropReady = 'true';
        modal.addEventListener('click', function (event) {
          if (event.target === modal) closeModal();
        });
      }
    });
  }

  updateConfig();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateConfig();
      improveModalSemantics(document);
    }, { once: true });
  } else {
    improveModalSemantics(document);
  }

  var scanScheduled = false;
  var observer = new MutationObserver(function () {
    if (scanScheduled) return;

    scanScheduled = true;
    window.setTimeout(function () {
      scanScheduled = false;
      updateConfig();
      improveModalSemantics(document);
    }, 0);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
